import React from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const SingleGaugeChart = ({ value = 0.6 }) => {
  // Determine color based on value ranges
  const getColorForValue = (value) => {
    if (value <= 0.3) return ['#FF0000', '#e0e0e0']; // Red for 0-30%
    if (value <= 0.7) return ['#FFEB3B', '#e0e0e0']; // Yellow for 30-70%
    return ['#4CAF50', '#e0e0e0']; // Green for 70-100%
  };

  const chartData = {
    datasets: [
      {
        data: [value * 100, 100 - value * 100],
        backgroundColor: getColorForValue(value), // Adjust color dynamically
        borderWidth: 0,
        circumference: 180,
        rotation: -90,
        cutout: '60%',
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      datalabels: {
        display: false, // to disables arc text like "80", "20"
      },
    },
  };

  return (
    <div
      id="gauge-chart"
      style={{ width: '100%', height: '120px', position: 'relative' }}
    >
      <Chart type="doughnut" data={chartData} options={chartOptions} />

      {/* Show value below the chart */}
      <div
        style={{
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '16px',
        }}
      >
        Likelihood of HDFC Life winning the case: {Math.round(value * 100)}%
      </div>
    </div>
  );
};

export default SingleGaugeChart;
